import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import gtm from '@/utils/gtm';
import EcoImg from 'eco-design/base/eco-img';
import Arrow from './arrow';
import styles from './index.module.scss';

const OnePicture: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('OnePicture');

    const items = [
        {
            title: t('title1'),
            desc: t('desc1'),
            href: '#Output',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761114630467-aae7kf-compressed-Frame%202094654446.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761114797507-9qwr95-compressed-Frame%201000008650.jpg',
        },
        {
            title: t('title2'),
            desc: t('desc2'),
            href: '#d3m-automotive',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761708844160-rk56if-compressed-Frame%202094654473.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761706593855-1uybi8-compressed-Frame%202094654493.jpg',
        },
        {
            title: t.rich('title3', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc3'),
            href: '#ChargeUp',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761732217858-wykpm5-compressed-Frame%202094654474.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761732252527-x8pfbq-compressed-Frame%202094654448.jpg',
        },
        {
            title: t('title4'),
            desc: t('desc4'),
            href: '#PriorityOutputsBlock',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761545316558-ewv74e-compressed-Frame%202094654472.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761116359868-emgphw-compressed-Frame%202094654471.jpg',
        },
        {
            title: t('title5'),
            desc: t('desc5'),
            href: '',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761114716624-b53pd3-compressed-Frame%202094654428.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761114937635-ist9l6-compressed-Frame%202094654433.jpg',
        },
        {
            title: t('title6'),
            desc: t('desc6'),
            href: '#phoneSection',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761114729389-1ctc3s-compressed-Frame%202094654427.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761115603651-3bla25-compressed-Frame%202094654418.jpg',
        },
        {
            title: t('title7'),
            desc: t('desc7'),
            href: '#TabSection',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761114739915-47n2ij-compressed-Frame%201612708206.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761114974790-2jvt2a-compressed-Frame%202094654449.jpg',
        },
        {
            title: t.rich('title8', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc8'),
            href: '',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1761114751533-qys13b-compressed-Frame%202094654425.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1761115624812-f4ij35-compressed-Frame%201000008978.jpg',
        },
    ];
    const handleScrollInToView = (href: string, className: string) => {
        const element = document.getElementById(href.replace('#', ''));
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }

        gtm.push({
            __btn_id1: `one-picture .${className}`,
            __btn_id2: className,
            __btn_type: 'common',
            __bth_only_ef: true,
        });
    };
    return (
        <div className={`${styles.OnePicture} one-picture GtmModuleData-section`} id="OnePicture" data-section-id="d3m-one-picture">
            <div className="content d3m-layout">
                <div
                    className="g-item g1 GtmModuleData-btn-common d3m-one-picture-0"
                    data-btn-id="d3m-one-picture-0"
                    onClick={() => handleScrollInToView(items[0].href || '', 'd3m-one-picture-0')}
                >
                    <EcoImg pc={items[0].pc} pad={items[0].h5} h5={items[0].h5} isOpenLazy={true} />
                    <div className="title-wrapper">
                        <div className="title">{items[0].title}</div>
                        <div className="desc">{items[0].desc}</div>
                    </div>
                    <div className="arrow">
                        <Arrow />
                    </div>
                </div>
                <div className="wrapper">
                    {items.slice(1).map((item, index) => (
                        <div
                            key={index}
                            className={`g-item g${index + 2} GtmModuleData-btn-common d3m-one-picture-${index}`}
                            data-btn-id={`d3m-one-picture-${index}`}
                            onClick={() => handleScrollInToView(item.href || '', `d3m-one-picture-${index}`)}
                        >
                            <EcoImg pc={item.pc} pad={item.pc} h5={item.h5} isOpenLazy={true} />
                            <div className="title-wrapper">
                                <div className="title">{item.title}</div>
                                <div className="desc">{item.desc}</div>
                            </div>
                            <div className="arrow">
                                <Arrow />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default OnePicture;
